import { API_PATHS } from "../constants/api-paths";
import { IResponse, encryptedRequest } from "../core/api.client";

export interface IAddOnProd {
  prodType?: string;
  prodName?: string;
  premium?: string;
  coverage?: string;
  tenure?: string;
  isSelected?: boolean;
}

export interface IBlInsertApiRequest {
  mobileNo: string;
  journeyName: string;
  custType?: string;
  offerId?: string;
  offerName?: string;
  loanAmt?: string;
  offerAmt?: string;
  tenureInMon?: string;
  loanVariant?: string;
  initialTenor?: string;
  subsequentTenor?: string;
  roi?: string;
  droplineEmiAmt?: string;
  hybridEmiAmt?: string;
  droplineEMIAmt?: string;
  emiAmt?: string;
  actualEmiAmt?: string;
  maxLoanVariant?: string;
  maxLoanTenor?: string;
  addOnProd?: IAddOnProd[];
  appId?: string;
  custId?: string;
  profession?: string;
  subProfession?: string;
  utmSource?: string;
  utmMedium?: string;
}

export interface IBlInsertApiResponse {
  id: string;
  eventCode: string;
  journeyName: string;
  newLoanAmt: string;
  netDisbursalAmt: string;
  chargeDetails: string;
}

export type IBlseInsertApiRequest = {
  mobileNo: string;
  journeyName: string;
  custType?: string;
  offerId?: string;
  offerName?: string;
  loanAmt?: string;
  offerAmt?: string;
  tenureInMon?: string;
  loanVariant?: string;
  initialTenor?: string;
  subsequentTenor?: string;
  roi?: string;
  hybridEmiAmt?: string;
  droplineEmiAmt?: string;
  emiAmt?: string;
  actualEmiAmt?: string;
  maxLoanVariant?: string;
  maxLoanTenor?: string;
  addOnProd?: IAddOnProd[];
  appId?: string;
  journeyType: string;
  offerProduct: string;
  prodName: string;
  appVersion: string;
  custId?: string;
  profession?: string;
  subProfession?: string;
};

export type IBlseInsertApiResponse = {
  id: string;
  eventCode: string;
  journeyName: string;
  newLoanAmt: string;
  netDisbursalAmt: string;
  chargeDetails: string;
};

export const postBlInsert = async (
  blInsertRequestData: IBlInsertApiRequest
): Promise<IResponse<IBlInsertApiResponse>> => {
  const response = await encryptedRequest<IBlInsertApiResponse, IBlInsertApiRequest>({
    method: "POST",
    url: API_PATHS.blInsert,
    data: blInsertRequestData,
  });

  return response;
};

export const postBlseInsert = async (
  blseInsertRequestData: IBlseInsertApiRequest
): Promise<IResponse<IBlseInsertApiResponse>> => {
  const response = await encryptedRequest<IBlseInsertApiResponse, IBlseInsertApiRequest>({
    method: "POST",
    url: API_PATHS.blseInsert,
    data: blseInsertRequestData,
  });

  return response;
};
